<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/main" />
    </ion-buttons>
    <ion-title>{{ "VENDORS.CREATE_VENDOR" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <form class="max-w-[600px] mx-auto" [formGroup]="form" (ngSubmit)="submit()">
    <fieldset [disabled]="form.disabled">
      <div class="flex flex-col items-center justify-center gap-8">
        <div class="mt-4 mb-4 size-44 aspect-square">
          <mtjr-attachment-field
            [singleMode]="true"
            [field]="form.controls.logo"
            borderRadiusClass="rounded-full"
            labelTr="VENDORS.LOGO_IMAGE"
          />
        </div>
      </div>

      <div class="aspect-[2/0.75] my-4">
        <mtjr-attachment-field
          [singleMode]="true"
          [field]="form.controls.background"
          [labelTr]="'VENDORS.BACKGROUND_IMAGE'"
          borderRadiusClass="rounded-xl"
        />
      </div>
      <mtjr-text-field
        data-cy="vendor-name-input"
        [field]="form.controls.name"
        [label]="'VENDORS.NAME' | translate"
        class="w-full"
      />
      <div class="my-4"></div>

      @let addressStreet = createUtils.form.controls.addressStreet.value;
      <ion-card class="border-none !m-0 rounded-md">
        <ion-item lines="none">
          <ion-text class="font-bold">{{ "VENDORS.ADDRESS" | translate }}</ion-text>
          <ion-button
            slot="end"
            fill="clear"
            color="primary"
            [routerLink]="['/main/account/addresses']"
            [queryParams]="{ pickerMode: true, redirect: `/main/vendors/create` }"
          >
            <ion-text class="text-[1rem]">
              {{ (addressStreet ? "COMMON.CHANGE" : "COMMON.ADD") | translate }}
            </ion-text>
          </ion-button>
        </ion-item>
        @if (addressStreet) {
          <div class="bg-light ms-4 h-[1px]"></div>
          <ion-item lines="none">
            <ion-text>
              {{ createUtils.form.controls.addressLabel.value }}
              <span class="text-medium ms-1">{{ addressStreet }}</span>
            </ion-text>
          </ion-item>
        }
      </ion-card>
      <div class="my-8"></div>
    </fieldset>
    <div class="py-3">
      <mtjr-error-bar [failure]="createStore.vendorCreateFailure()" />
    </div>
    <div class="mb-2 flex justify-end">
      <mtjr-back-button [label]="'COMMON.CANCEL' | translate" />
      <mtjr-submit-button
        data-cy="vendor-update-button"
        [label]="'COMMON.SAVE' | translate"
        [state]="createStore.vendorCreateState()"
      />
    </div>
  </form>
</ion-content>
